import Icon from '@xo-union/tk-component-icons';
import { H4 } from '@xo-union/tk-ui-typography';
import { useLocation } from 'react-router-dom';
import React from 'react';

import { WeddingWebsiteQuery } from '../../generated/graphql';
import { basicInfoRailRoute } from '../../helpers/routes';
import { Link } from '../Link';
import LinkButton from '../LinkButton';
import styles from './basicInfo.scss';
import BasicInfoText from '../WeddingPageCard/BasicInfoText';
import useDatePref from '../../helpers/useDatePref';

interface Props {
  data?: WeddingWebsiteQuery;
}

const BasicInfoItem: React.FC<Props> = ({ data }) => {
  const { pathname } = useLocation();
  const [weddingDateText] = useDatePref({
    isLiteSite: true,
  });

  return (
    <Link to={basicInfoRailRoute(pathname.includes('preview'))}>
      <div className={styles.container}>
        <LinkButton data-testid="edit-icon-link-button" className={styles.editIcon}>
          <Icon name="edit" size="md" />
        </LinkButton>
        <div className={styles.basicInfoContainer}>
          <div className={styles.basicInfoSubContainer}>
            <H4 className={styles.name} as="h3">
              {data?.member?.firstName} &amp; {data?.member?.fianceFirstName}
            </H4>
            <BasicInfoText data={data} weddingDateText={weddingDateText} />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BasicInfoItem;
